import React, { useState, useEffect } from 'react';
import { useNavigate , useSearchParams} from 'react-router-dom';
import { SearchContainer, SearchLabel, Input } from './styles';
import { useGetApplicationsQuery } from '../../../../../../../../redux/services/ApplicationsApi';
import mapApplications, { ApplicationModel } from '../../../../../../../../utils/functions/map/mapApplications';
import { applicationsThArray } from '../../../../../../../../utils/constants/th_arrays';
import { Table } from '../../../../../../../../components/Table/Table';
import { Pagination } from '../../../../../../../../components/Pagination/Pagination';
import { CreateDispute } from '../../../CreateDispute/CreateDispute';
import modalStyles  from '../../../CreateDispute/CreateDispute.module.css'
import { type CSSProperties } from 'react';
import { statusesTranslate } from '../../statuses';
import { FilterValues } from '../../../CustomFilterModal/CustomFilterModal';
import {
  useGetOrderFilesQuery,
} from '../../../../../../../../redux/services/OrdersApi';
import { createPortal } from 'react-dom';
import {
  useGetFilesQuery,
} from '../../../../../../../../redux/services/WithdrawalsApi';
import { handleDownloadFile } from 'utils/functions/downloadFile';
import { Button } from 'components/Button/Button';
import styles from '../../../../../components/Filter/Filter.module.css';
import * as UI from './styles';
import { ModalDefault } from '../../../../../../../../components/ModalDefault/ModalDefault';
import { storageUrl } from 'utils/constants/url';
interface Props { filter?: FilterValues | null}


interface thModel {
  name: string;
  style?: CSSProperties;
}

const ApplicationsTable: React.FC<Props> = ({ filter }) => {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [highlightId, setHighlightId] = useState<string | null>(null);
  const { data, error, isLoading } = useGetApplicationsQuery(
    undefined,
    { pollingInterval: 10000 }
  );
  const [page, setPage] = React.useState(1);
  const [searchId, setSearchId] = useState('');
  const [disputeOrderId, setDisputeOrderId] = React.useState<string | null>(null);
  const [disputeWithdrawalId, setDisputeWithdrawalId] = React.useState<string | null>(null);
  const [isDisputeOpen, setIsDisputeOpen] = React.useState(false);

  const [infoApp, setInfoApp]           = useState<ApplicationModel | null>(null)
  const [isInfoOpen, setIsInfoOpen]     = useState(false)
  const [menuOpenFor, setMenuOpenFor] = useState<string | null>(null);

      const [openModal, setOpenModal] = useState(false);
    const [orderUid, setOrderUid] = useState<string | null>(null);
    const [withdrawalUid, setWithdrawalUid] = useState<string | null>(null);
  useEffect(() => {
      const highlight = searchParams.get('highlight');
      if (highlight) {
        setHighlightId(highlight);
        searchParams.delete('highlight');
        setSearchParams(searchParams);
      }
  }, [searchParams, setSearchParams]);

    // Для заказов (Пополнения)
    const { data: ordersFiles, refetch: refetchOrderFiles } = useGetOrderFilesQuery(
      { id: `${orderUid}` || '' },
      {
        skip: !orderUid,
        pollingInterval: openModal ? 10000 : 0,
        refetchOnMountOrArgChange: true,
      }
    );

    // Для выплат
    const { data: withdrawalFiles, refetch: refetchWithdrawalFiles } = useGetFilesQuery(
      { id: `${withdrawalUid}` || '' },
      {
        skip: !withdrawalUid,
        pollingInterval: openModal ? 10000 : 0,
        refetchOnMountOrArgChange: true,
      }
    );
  if (isLoading) {
    return <div>Загрузка заявок...</div>;
  }
  if (error) {
    return <div>Ошибка загрузки заявок</div>;
  }
  if (!data || data.length === 0) {
    return <div className="no-data-icon">Нет заявок для отображения</div>;
  }


const GROUP_STATUS_CODES: Record<string, string[]> = {
    new:           ['BN'],
    in_progress:   ['IP'],
    dispute:       ['ID'],
    success:       ['SF', 'AA', 'AAD'],
    recalculations:['UR', 'FR', 'CR'],
    errors:        ['NF', 'TO'],
    canceled_grp:  ['CANCELED'],
    support:       ['STS', 'STSD', 'PC'],
};

// Применяем наш фильтр
    let filtered = data;
    if (filter) {
        if (filter.type !== 'all') {
            filtered = filtered.filter(app => app.type === filter.type);
        }
        if (filter.status !== 'all') {
            filtered = filtered.filter(app => GROUP_STATUS_CODES[filter.status].includes(app.status));
        }
        if (filter.amountFrom !== '') {
            filtered = filtered.filter(app => app.final_amount >= filter.amountFrom);
        }
        if (filter.amountTo !== '') {
            filtered = filtered.filter(app => app.final_amount <= filter.amountTo);
        }
        if (filter.dateFrom) {
            filtered = filtered.filter(app => new Date(app.date) >= new Date(filter.dateFrom));
        }
        if (filter.dateTo) {
            filtered = filtered.filter(app => new Date(app.date) <= new Date(filter.dateTo));
        }
    }


  let filteredData = searchId
     ? filtered.filter(app => app.id.includes(searchId))
     : filtered;

   if (highlightId) {
      filteredData = [...filteredData].sort((a, b) =>
      String(a.id) === highlightId ? -1 :
      String(b.id) === highlightId ?  1 : 0
    );
  }
  // Простейшая клиентская пагинация
  const pageSize = 7;
  const totalPages = Math.ceil(filteredData.length / pageSize);

  // Убедимся, что текущая страница не выходит за границы
  const safePage = page > totalPages ? totalPages : page;
  const startIndex = (safePage - 1) * pageSize;
  const pagedData = filteredData.slice(startIndex, startIndex + pageSize);

  const mappedRows: ApplicationModel[] = mapApplications(pagedData);
  const selectedApp = mappedRows.find((row) => row.id === (orderUid || withdrawalUid));
   const linkStyle: CSSProperties = {
      cursor: 'pointer',
      color: 'blue',
      textDecoration: 'none',
    };
  // Добавляем колонку для кнопки создания диспута
  const tdArray = mappedRows.map((row) => [
      {
        element:
          row.has_files ? (
            <a
              style={linkStyle}
              onClick={() => {
                setOpenModal(true);
                if (row.type === 'Пополнение') {
                  setOrderUid(row.id);
                  setWithdrawalUid(null);
                  refetchOrderFiles();
                } else if (row.type === 'Выплата') {
                  setWithdrawalUid(row.id);
                  setOrderUid(null);
                  refetchWithdrawalFiles();
                }
              }}
            >
              {row.id}
            </a>
          ) : (
            row.id
          ),
        style: undefined,
      },
    { element: row.date, style: undefined },
    { element: row.type, style: undefined },
    { element: row.course, style: undefined },
    { element: `${row.final_amount} ${row.currency}`, style: undefined },
    { element: statusesTranslate[row.status] ?? row.status, style: undefined },
    {
      element: (
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            aria-label="Меню действий"
            onClick={() => setMenuOpenFor(menuOpenFor === row.id ? null : row.id)}
            style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
          >
            <img src='/points.svg' alt="⋮"style={{ display: 'inline-block', width: 16, height: 16 }}/>
          </button>

          {menuOpenFor === row.id && (
            <div
              style={{
                position: 'absolute',
                top: 32,
                right: 0,
                background: '#fff',
                border: '1px solid #E2E8F0',
                borderRadius: 4,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                zIndex: 100,
                minWidth: 160,
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setInfoApp(row);
                  setIsInfoOpen(true);
                  setMenuOpenFor(null);
                }}
                style={{ display: 'flex', alignItems: 'center', padding: '8px 16px',  width: '100%', whiteSpace: 'nowrap',  borderBottom: '1px solid #E2E8F0', background: 'none', border: 'none', cursor: 'pointer' }}
              >
                <img src='/info.svg' alt="" width={16} height={16} style={{ marginRight: 8 }} />
                Информация
              </button>
              <button
                type="button"
                onClick={() => {
                  if (row.type === 'Выплата') {
                      setDisputeWithdrawalId(row.id);
                      setDisputeOrderId(null);
                    } else {
                      setDisputeOrderId(row.id);
                      setDisputeWithdrawalId(null);
                    }
                    setIsDisputeOpen(true);
                    setMenuOpenFor(null);
                  }
              }
                  style={{ display: 'flex', alignItems: 'center', padding: '8px 16px',  width: '100%', whiteSpace: 'nowrap',  borderBottom: '1px solid #E2E8F0', background: 'none', border: 'none', cursor: 'pointer' }}
              >
                <img src='/dispute_icon.svg' alt="" width={16} height={16} style={{ marginRight: 8 }} />
                Открыть спор
              </button>
            </div>
          )}
        </div>

      ),
      style: undefined,
    },
  ]);

  // Расширяем заголовки
 const extendedThArray: thModel[] = [
    ...applicationsThArray,
    { name: '', style: undefined },
  ];

  // Вычисляем следующую и предыдущую страницы с учётом safePage
  const nextPage = safePage < totalPages ? safePage + 1 : totalPages;
  const previousPage = safePage > 1 ? safePage - 1 : 1;

  return (
    <div>
      <SearchContainer>
        <Input
          type="text"
          placeholder="Поиск"
          value={searchId}
          onChange={e => {
            setSearchId(e.target.value);
            setPage(1);
          }}
        />
      </SearchContainer>
      <Table tableId='merchant-applications' thArray={extendedThArray} tdArray={tdArray} />
      <Pagination
        totalPages={totalPages}
        currentPage={safePage}
        setCurrentPage={setPage}
        nextPage={nextPage}
        previousPage={previousPage}
      />

      {isDisputeOpen && (disputeOrderId || disputeWithdrawalId) && (
        <CreateDispute
          orderId={disputeOrderId || undefined}
          withdrawalId={disputeWithdrawalId || undefined}
          onClose={() => {
            setIsDisputeOpen(false);
            setDisputeOrderId(null);
            setDisputeWithdrawalId(null);
          }}
          onSuccess={() => {
            setIsDisputeOpen(false);
            setDisputeOrderId(null);
            setDisputeWithdrawalId(null);
          }}
        />
      )}

    {isInfoOpen && infoApp && (
      <div className={modalStyles.backdrop}>
        <div className={modalStyles.modal}>
          <button onClick={() => setIsInfoOpen(false)} className={modalStyles.closeBtn}>×</button>
          <h2 className={modalStyles.title}>Информация</h2>
          <div className={modalStyles.form}>
            {infoApp.disputes.length > 0 && (
              <div className={modalStyles.field}>
                <button
                  type="button"
                  className={modalStyles.spotButton}
                  onClick={() => {
                   const id = infoApp.disputes[0]
                   const tab = infoApp.status === 'ID' ? 'open' : 'resolved';
                   const page = 1
                   navigate(`/merchant/disputes?tab=${tab}&page=${page}&highlight=${id}`)
                 }}
                >
                  Открытый спор #{infoApp.disputes[0]}
                </button>
              </div>
            )}

            <div className={modalStyles.field}>
              <label>ID заявки</label>
              <div>{infoApp.id}</div>
            </div>
            <div className={modalStyles.field}>
              <label>ID заявки мерчанта</label>
              <div>{infoApp.merchant_order_id}</div>
            </div>
            <div className={modalStyles.field}>
              <label>ID клиента мерчанта</label>
              <div>{infoApp.merchant_client_id}</div>
            </div>
            <div className={modalStyles.field}>
              <label>Создано</label>
              <div>{new Date(infoApp.date).toLocaleString()}</div>
            </div>
            <div className={modalStyles.field}>
              <label>Банк</label>
              <div>{infoApp.bank}</div>
            </div>
            <div className={modalStyles.field}>
              <label>Тип заявки</label>
              <div>
                <span
                  className={
                    infoApp.type === 'Пополнение'
                      ? modalStyles.depositLabel
                      : modalStyles.withdrawLabel
                  }
                >
                  {infoApp.type.toLowerCase()}
                </span>
              </div>
            </div>
            <div className={modalStyles.field}>
              <label>Сумма</label>
              <div>{infoApp.amount} {infoApp.currency}</div>
            </div>
            <div className={modalStyles.field}>
              <label>Курс</label>
              <div>{infoApp.course} {infoApp.currency} — USDT</div>
            </div>
            <div className={modalStyles.field}>
              <label>Статус</label>
              <div>{statusesTranslate[infoApp.status] ?? infoApp.status}</div>
            </div>
          </div>
        </div>
      </div>
    )}


    {openModal &&
  (orderUid || withdrawalUid) &&
  selectedApp &&
  (ordersFiles || withdrawalFiles) &&
  createPortal(
    <ModalDefault
      title={'Превью'}
      titleMargin={'12px'}
      active={openModal}
      setActive={() => {
        setOpenModal(false);
        setOrderUid(null);
        setWithdrawalUid(null);
      }}
    >
      {/* Комментарии берем сразу из selectedApp */}
      {selectedApp.comments &&
        Object.entries(selectedApp.comments).filter(([, text]) => text.trim().length).length >
          0 && (
          <div className={modalStyles.commentsContainer}>
            <h4>Комментарии</h4>
            {Object.entries(selectedApp.comments).map(([idx, text]) => (
              <p key={idx}>
                <strong>{Number(idx)+1}.</strong> {text}
              </p>
            ))}
          </div>
        )}

      {/* Изображения */}
      {((ordersFiles?.files || withdrawalFiles?.files) ?? [])
        .filter((f) => f.file_type === 'picture').length > 0 && (
        <div className={modalStyles.previewImagesContainer}>
          <div className={styles.previewFiles}>
            {((ordersFiles?.files || withdrawalFiles?.files) ?? [])
              .filter((f) => f.file_type === 'picture')
              .map((file) => (
                <img
                  src={`${storageUrl}${file.url}`}
                  alt="preview"
                  width={'100%'}
                  height={'100%'}
                  key={file.url}
                />
              ))}
          </div>
        </div>
      )}

      {/* Остальные файлы */}
      {((ordersFiles?.files || withdrawalFiles?.files) ?? [])
        .filter((f) => f.file_type !== 'picture').length > 0 && (
        <div className={modalStyles.previewImagesContainer}>
          <div className={styles.previewButtons}>
            {((ordersFiles?.files || withdrawalFiles?.files) ?? [])
              .filter((f) => f.file_type !== 'picture')
              .map((file) => (
                <Button
                  style={{
                    padding: '6px 12px',
                    border: 'none',
                    backgroundColor: '#cccccc',
                    color: 'black',
                    maxWidth: '300px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  type="button"
                  action={() => handleDownloadFile(file.url, file.file_type)}
                  key={file.url}
                >
                  <span>{file.file_type}</span>
                </Button>
              ))}
          </div>
        </div>
      )}
    </ModalDefault>,
    document.body
  )}
    </div>
  );
};

export default ApplicationsTable;
